module.exports = __webpack_public_path__ + "img/sunkeeper.f2e2c5fa.png";